import React from "react";

const IncludedSection = ({ mainImage, heading, items }) => {
  return (
    <section className="flex flex-col bg-light lg:flex-row items-center gap-8 px-4 md:px-6 py-8 md:py-12 max-w-6xl mx-auto">
      
      {/* Left Side - Image */}
      <div className="relative w-full lg:w-1/2 flex justify-center">
        <img
          src={mainImage}
          alt="Main Retreat"
          className="rounded-lg shadow-lg w-full max-w-xs md:max-w-sm lg:max-w-md h-auto object-cover"
        />
      </div>

      {/* Right Side - Content */}
      <div className="w-full lg:w-1/2 flex flex-col items-center">
        <h2 className="text-2xl md:text-3xl font-bold text-secondary text-center mb-4 md:mb-6">
          {heading}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 md:gap-6">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex items-start p-3 md:p-3 rounded-lg hover:bg-white transition duration-300 hover:scale-105 hover:shadow-lg"
            >
              <span className="text-green-600 text-sm md:text-xl mr-3">{item.icon}</span>
              <div>
                <h3 className="font-semibold text-primary text-md md:text-xl">{item.title}</h3>
                <p className="text-gray-600 text-sm md:text-base">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Button Always Below the Text */}
      </div>
      
    </section>
  );
};

export default IncludedSection;
